module.exports = __webpack_public_path__ + "static/img/cont43_08.447bee3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont43_08.jpg
// module id = fuPt
// module chunks = 0